import {defineStore} from "pinia";
import useCrudStore from "@/store/composables/crud";
import environment from "@/environment";
import useCancelTokenStore from "@/store/composables/cancel-token";
import http from "@/tools/http-client";

export const useCartStore
    = defineStore('CartStore', () => {

    const crud = useCrudStore(environment.appConfig.baseApiUrl + "cart");


    const cancelTokenStore = useCancelTokenStore();
    async function loadCart() {
        console.log("loadCart");
        crud.startLoading();
        try {
            const resp = await http.get(crud.endpoint.value + '/index?page=1&per_page=100');
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            crud.clearLoading();
            crud.setData(resp.data.cart_items || []);
        } catch (e) {
            crud.setError(e);
        }
    }
    async function addCart({price_list_item_id, comment, qnt, coin_id }) {
        crud.startLoading();
        try {
            const resp
                = await http.post(crud.endpoint.value + '/add', {price_list_item_id, comment, qnt, coin_id});
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            crud.clearLoading();
            crud.addItems([resp.data.item]);
        }catch (e) {
            crud.setError(e);
        }
    }
    async function deleteCart({ids}) {
        console.log("deleteCart");
        crud.startLoading();
        try {
            const resp
				= await http.delete(
                    crud.endpoint.value + '/del',
                {params: {id: ids}, paramsSerializer: {indexes: false}}
            );
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            crud.clearLoading();
            await  loadCart();
        } catch (e) {
            crud.setError(e);
        }
    }
    async function updateQnt({qnt, id}) {
        console.log("updateQnt");
        if(qnt < 1) {
            await deleteCart({ids: [id]})
            return;
        }
        cancelTokenStore.acquireToken();
        crud.startLoading();
        try {
            const resp
                = await http.post(
                crud.endpoint.value + '/upd',
                {qnt, id},
                {cancelToken: cancelTokenStore.cancelToken.value}
            );
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            crud.clearLoading();
            const found = crud.items.value
                .find(item => item.id === resp.data.item.id);
            if(found){
                found.qnt = resp.data.item.qnt;
            }
        } catch (e) {
            crud.setError(e);
        }
    }

    async function updateSelected({selected, id}, token) {
        console.log("updateSelected");
        if(!token) {
            cancelTokenStore.acquireToken();
        }
        crud.startLoading();
        try {
            const resp
                = await http.put(
                crud.endpoint.value + '/upd',
                {selected, id},
                {cancelToken: token || cancelTokenStore.cancelToken.value}
            );
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            crud.clearLoading();
            const found = crud.items.value
                .find(item => item.id === resp.data.item.id);
            if(found){
                found.selected = resp.data.item.selected;
            }
        } catch (e) {
            crud.setError(e);
        }
    }
    async function setSelected(selected) {
        console.log("setSelected", selected);
        const oldSelected =
            crud.items.value
                .filter(item => item.selected)
                .map(item => item.id)

        // Смотрю у кого надо снять/поставить селект
        const toRemoveSelect = oldSelected.filter(oldId => !selected.find(id => id === oldId))

        const toAddSelect = selected.filter(id => !oldSelected.find(oldId => id === oldId))
        cancelTokenStore.acquireToken();

        await Promise.all(
            toRemoveSelect.map((id) =>
                updateSelected({ selected: false, id }, cancelTokenStore.cancelToken.value))
        );
        await Promise.all(
            toAddSelect.map((id) =>
                updateSelected({selected: true, id},  cancelTokenStore.cancelToken.value))
        );
    }
    return {
        ...crud,
        loadCart,
        addCart,
        deleteCart,
        updateQnt,
        setSelected
    }
});
